import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { NoResultsFound } from '../../../img/ServerErrorSVG';
import './DataNotFound.scss';
import { useTranslation } from 'react-i18next';

const DataNotFound = ({ searchText }) => {
  const { t } = useTranslation();
  return (
    <div className="data-not-found mt-4">
      <Row>
        <Col>
          <div className="data-not-found-container d-flex flex-column flex-md-row justify-content-left align-items-center align-items-md-start">
            <NoResultsFound />
            <div className="content-box">
              <h3 className="mb-4" role="alert">
                {t('data_not_found.no_results')}{' '}
              </h3>
              <p>
                {t('data_not_found.could_not_match')}{' '}
                <span className="font-weight-bold">{searchText}</span>. <br />{' '}
                {t('data_not_found.another_search')}
              </p>
              <div className="search-tips">
                <p className="my-4">{t('data_not_found.search_tips')}</p>
                <ul>
                  <li>{t('data_not_found.spelling_keywords')} </li>
                  <li>{t('data_not_found.try_broader')}</li>
                  <li>{t('data_not_found.fewer_keywords')}</li>
                </ul>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DataNotFound;
